export function certificateDateStatus(certificate: { validFrom: string; validTo: string }, now: number): string {
  const start = Date.parse(certificate.validFrom);
  const end = Date.parse(certificate.validTo);
  if (!Number.isFinite(start) || !Number.isFinite(end) || start >= end) return 'Unknown dates';
  if (start > now) return 'Not yet valid';
  if (end <= now) return 'Expired';
  if (end - now <= 30 * 86400000) return 'Expiring soon';
  return 'Within validity dates';
}
